<ng-container *transloco="let convert;">
  @if (dealersState | async; as dealersState) {
    <div class="">
      <div class="form-group">
        <label class="text-uppercase d-block"
          >{{convert('common.labelSearch')}}
          <input type="text" class="form-control" (input)="search($event)" />
        </label>
      </div>
      @if (dealersState) {
        <div>
          <ul>
            @if ((dealerList$ | async)?.length > 1) {
              <li class="custom-control custom-checkbox">
                <input
                  class="custom-control-input"
                  id="dealer-option-1"
                  type="checkbox"
                  data-track-elem="checkbox"
                  data-track-trigger="filter"
                  data-track-name="Select All"
                  [checked]="dealersState.selectAllChecked"
                  (change)="toggleAllDealers()"
                  aria-labelledby="dealer-option-1__label"
                  #selectAllDealers
                  />
                <label id="dealer-option-1__label" class="custom-control-label ms-2" for="dealer-option-1"
                  >{{convert('sellModule.manageInventory.dealerFilter.labelSelectAll')}}</label
                  >
                </li>
              }
              @for (dealer of dealerList$ | async | slice: 0:(dealersShown$ | async); track dealerById($index, dealer)) {
                <li
                  class="custom-control custom-checkbox"
                  >
                  <input
                    class="custom-control-input"
                    [attr.id]="'dealer-offers-' + dealer.organizationEntityUuid"
                    type="checkbox"
                    [checked]="dealer.selected"
                    data-track-elem="checkbox"
                    data-track-trigger="filter"
                    [attr.data-track-name]="dealer.name"
                    [value]="dealer.organizationEntityUuid"
                    [attr.aria-labelledBy]="'dealer-offers-' + dealer.organizationEntityUuid + '__label'"
                    (change)="checkDealer(dealer.organizationEntityUuid, $event)"
                    #dealerWithCheckbox
                    />
                  <label
                    [attr.id]="'dealer-offers-' + dealer.organizationEntityUuid + '__label'"
                    class="custom-control-label ms-2 dealer-name-word-break"
                    [attr.for]="'dealer-offers-' + dealer.organizationEntityUuid"
                    >{{ dealer.name }}</label
                    >
                  </li>
                }
              </ul>
              @if ((dealerList$ | async)?.length > initialDealersShown) {
                <button
                  class="text-primary fw-bold btn-link px-2 mb-1"
                  (click)="showMoreLess.next()"
                  [appTrackButton]="(showMore$ | async) ? convert('search.common.collapsableList.btnShowMore') : convert('search.common.collapsableList.btnShowLess')"
                  >
                  {{ (showMore$ | async) ? convert('search.common.collapsableList.btnShowMore') : convert('search.common.collapsableList.btnShowLess') }}
                </button>
              }
            </div>
          }
        </div>
      }
    </ng-container>
